/** What Cai can be asked to take on, and whether this fleet has turned it on. */
export enum Capability {
  INSURANCE = 'INSURANCE',
  COMPLIANCE = 'COMPLIANCE',
  CFO = 'CFO',
  BOOKKEEPING = 'BOOKKEEPING',
  FUEL = 'FUEL',
}

export interface CapabilityProfile {
  /** How the Connect tab names it: what Cai does for you. */
  name: string
  /** How the Ideas tab heads its group: the thing itself. */
  short: string
  /** Absent when it comes with the account. */
  price?: string
  cta: string
  /** CFO is the only one this fleet has turned on; the rest are offers. */
  enabled: boolean
}

export const CAPABILITIES: Record<Capability, CapabilityProfile> = {
  [Capability.INSURANCE]: {
    name: 'Providing insurance',
    short: 'Insurance',
    cta: 'Get your quotes',
    enabled: false,
  },
  [Capability.BOOKKEEPING]: {
    name: 'Bookkeeping',
    short: 'Bookkeeping',
    price: '$59/mo',
    cta: 'Set up now',
    enabled: false,
  },
  [Capability.COMPLIANCE]: {
    name: 'Managing compliance',
    short: 'Compliance',
    price: '$15/mo',
    cta: 'Get started',
    enabled: false,
  },
  [Capability.CFO]: {
    name: 'Financial forecasting with CFO',
    short: 'CFO',
    price: '$99/mo',
    cta: 'Enable',
    enabled: true,
  },
  [Capability.FUEL]: {
    name: 'FuelApp',
    short: 'Fuel',
    price: 'Free',
    cta: 'Save on diesel',
    enabled: false,
  },
}

/** How a capability's Overview is named wherever something can be pinned to it. */
export function overviewTarget(entry: Capability): string {
  return `${CAPABILITIES[entry].short} overview`
}

export const CAPABILITY_ORDER = [
  Capability.INSURANCE,
  Capability.COMPLIANCE,
  Capability.CFO,
  Capability.BOOKKEEPING,
  Capability.FUEL,
]
